import { Model } from '@danangelus/ngx-app-core'

/**
 * A generic error class
 *
 * @author Dan Bennett
 */
export class GatewayError extends Model {

    error: string | undefined
    message: string | undefined

    constructor(e?: any) {
        super(e)
    }
}

/**
 * An error returned by the service due to an authentication error
 *
 * @author Dan Bennett
 */
export class SessionError extends GatewayError {

    ssoTicketId: string | undefined
    username: string | undefined
}

export declare class Page {

    content: any[]
    totalElements: number
    size: number
}

/**
 * A custom script to be loaded into the header
 *
 * @author Dan Bennett
 */
export declare class Script {
    name: string | undefined;
    type: string | undefined;
    content: string | undefined;
    src: string | undefined;
    params: any | undefined;
}
